import React from "react";
import { selectSearchedSteelGradeIds } from "src/store/slices/steelGradeSearchSlice";
import { useAppSelector } from "src/store/store";
import { PlanId } from "../boundary/PlanId";
import { Period } from "hooks/periodIndex";

export const useFilterModel = (
  planId: PlanId,
  period: Period,
  view: "deploy" | "supervisor" | "backup"
) => {
  const selectedSteelGradeIds = useAppSelector((state) =>
    selectSearchedSteelGradeIds(state, planId, period, view)
  );

  const filterModel = React.useMemo(
    () => ({
      items: [
        {
          id: "steelGrades",
          field: "steel_grades",
          operator: "contains",
          value: selectedSteelGradeIds,
        },
      ],
    }),
    [selectedSteelGradeIds]
  );

  return filterModel;
};
